/**
 * Alert
 */

// Module Dependencies
import 'protons';

// Module template
import './_alert.twig';

// Module styles
import './_alert.scss';

export const name = 'alert';

export function disable() {}

export function enable() {}

export default enable;
